




















































































import { Component, Prop } from 'vue-property-decorator';
import Avatar from '@/components/common/Avatar.vue';
import { IDamage, DamageStatus } from 'admiral-core';
import ProductBadge from '@/components/common/ProductBadge.vue';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'DamageListItem',
  components: {
    ProductBadge,
    Avatar,
  },
})
export default class DamageListItem extends mixins(BaseMixin) {
  @Prop({ type: Object, required: true }) damage!: IDamage;

  formatDate(date: Date | string | undefined) {
    if (!date) return '';
    return dayjs(date).format('DD.MM.YYYY');
  }

  get isOverdue() {
    if (!this.damage.dueAt) return false;

    // Nur bei aktiven Status-Werten die Warning-Farbe anzeigen
    const activeStatuses = [
      DamageStatus.NEW,
      DamageStatus.IN_PROGRESS,
      DamageStatus.PENDING,
      DamageStatus.SUBMITTED,
    ];

    if (!activeStatuses.includes(this.damage.status)) return false;

    return dayjs(this.damage.dueAt).isBefore(dayjs(), 'day');
  }
}
